/* @flow */
import React from 'react';
import { InsurancesPageService } from 'frilans-finans';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import counterpart from 'counterpart';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';

export class InsurancesPage extends React.Component {

  constructor (props) {
    super(props);

    this.state = {
      page: null,
      pendingRequest: null
    };

    this.renderTabPanel = this.renderTabPanel.bind(this);
    this.renderLetterBox = this.renderLetterBox.bind(this);
  }

  componentDidMount () {
    this.fetch();
  }

  componentWillUnmount () {
    if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
      this.state.pendingRequest.cancel();
    }
  }

  fetch () {
    let pageID = 293;
    let pendingRequest;

    if (counterpart.getLocale() === 'en') {
      pageID = 523;
    }
    pendingRequest = InsurancesPageService.get(pageID);
    pendingRequest.promise
      .then((response) => {
        this.setState({
          page: response
        });
      })
      .catch(() => {});

    this.setState({
      pendingRequest: pendingRequest
    });
  }

  createMarkup (html) {
    return {__html: html};
  }

  renderLetterBox (page) {
    return (
      <div className="insurances-letters">
        <div className="row">
          <div className="col-xs-12 col-md-6 col-md-offset-3">
            <h2>{page.insurancesLetterButton}</h2>
            <div dangerouslySetInnerHTML={this.createMarkup(page.insurancesLetterBox)} />
          </div>
        </div>
      </div>
    );
  }

  renderHero (page) {
    var sectionStyle = {
      backgroundImage: 'url('+ page.insurancesImage +')'
    };
    return (
      <section className="page-hero" style={sectionStyle}>
        <div className="container">
          <p>{page.insurancesIngress}</p>
          <h1 className="white">{page.title}</h1>
        </div>
      </section>
    );
  }

  renderIntroText (page) {
    return (
      <section className="insurances-text">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <p>{page.insurancesText}</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  renderTab (section, i) {
    return (
      <Tab key={i}>
        <button className="tab-btn">{section.insurances_section_title}</button>
      </Tab>
    );
  }

  renderTabPanel (section, i) {
    return (
      <TabPanel key={i}>
        <div dangerouslySetInnerHTML={this.createMarkup(section.insurances_section_text)} />
      </TabPanel>
    );
  }

  renderTabs (page) {
    return (
      <Tabs>
        <TabList className='row'>
          {page.insurancesSections.map(this.renderTab)}
        </TabList>

        {page.insurancesSections.map(this.renderTabPanel)}
      </Tabs>
    );
  }

  render () {
    if (this.state.page) {
      return (
        <div className="insurances-page">
          <h2>{proxyCounterpart('INSURANCES')}</h2>
          {this.renderIntroText(this.state.page)}
          {this.renderTabs(this.state.page)}
        </div>
      );
    }

    return false;
  }
}

export default InsurancesPage;



/** WEBPACK FOOTER **
 ** ./src/views/insurances/insurances-page.js
 **/